import React from 'react'
import DetailsBox from '../../../../components/Cards/DetailsBox'

const WelfareModule = ({ welfare }) => (
  <DetailsBox
    title="Welfare"
    rows={[
      { label: 'Category', value: welfare?.category },
      { label: 'What Happened', value: welfare?.details },
      { label: 'Person Description', value: welfare?.personDescription },
      { label: 'Actions Taken', value: welfare?.actionsTaken },
      { label: 'Outcome', value: welfare?.outcome },
      { label: 'Outcome Notes', value: welfare?.outcomeNotes },
    ]}
  />
)

export default WelfareModule
